const ANONYMOUS_ID_KEY = "anonymous_trial_id";
const ANONYMOUS_LOCKED_KEY = "anonymous_trial_locked";
let fingerprintPromise = null;

function createAnonymousId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `anon_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getAnonymousId() {
  let id = localStorage.getItem(ANONYMOUS_ID_KEY);
  if (!id) {
    id = createAnonymousId();
    localStorage.setItem(ANONYMOUS_ID_KEY, id);
  }
  return id;
}

export function hasAnonymousId() {
  return Boolean(localStorage.getItem(ANONYMOUS_ID_KEY));
}

export function clearAnonymousId() {
  localStorage.removeItem(ANONYMOUS_ID_KEY);
}

export function startAnonymousTrial() {
  return getAnonymousId();
}

export function markAnonymousTrialLocked() {
  localStorage.setItem(ANONYMOUS_LOCKED_KEY, "1");
}

export function clearAnonymousTrialLock() {
  localStorage.removeItem(ANONYMOUS_LOCKED_KEY);
}

export function isAnonymousTrialLocked() {
  return localStorage.getItem(ANONYMOUS_LOCKED_KEY) === "1";
}

function getLanguage() {
  if (typeof navigator === "undefined") return "";
  return navigator.language || navigator.languages?.[0] || "";
}

function getPlatform() {
  if (typeof navigator === "undefined") return "";
  return navigator.userAgentData?.platform || navigator.platform || "";
}

function getTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
}

function getFingerprintSource() {
  if (
    typeof window === "undefined" ||
    typeof navigator === "undefined" ||
    typeof screen === "undefined"
  ) {
    return "server";
  }

  return JSON.stringify({
    ua: navigator.userAgent || "",
    lang: getLanguage(),
    langs: navigator.languages || [],
    platform: getPlatform(),
    timezone: getTimezone(),
    width: window.screen.width,
    height: window.screen.height,
    colorDepth: window.screen.colorDepth,
    pixelRatio: window.devicePixelRatio || 1,
    touchPoints: navigator.maxTouchPoints || 0,
    memory: navigator.deviceMemory || 0,
    cores: navigator.hardwareConcurrency || 0,
  });
}

async function sha256Hex(value) {
  if (typeof crypto !== "undefined" && crypto.subtle) {
    const encoded = new TextEncoder().encode(value);
    const digest = await crypto.subtle.digest("SHA-256", encoded);
    return Array.from(new Uint8Array(digest))
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("");
  }

  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return `fallback_${Math.abs(hash)}`;
}

export async function getAnonymousFingerprint() {
  if (!fingerprintPromise) {
    fingerprintPromise = sha256Hex(getFingerprintSource());
  }
  return fingerprintPromise;
}

export async function getAnonymousRequestContext() {
  return {
    anonymousId: getAnonymousId(),
    fingerprint: await getAnonymousFingerprint(),
    timezone: getTimezone(),
    language: getLanguage(),
    platform: getPlatform(),
  };
}
